<template>
	<a :href="itemLink" class="card course-card card-horizontal block md:flex">
	  	<div class="card-media" :style="cardMediaStyle" v-waves.block.light>
	    	<img class="card-media-image" :src="item.preview" alt="">
			<span class="card-label card-label-floating card-label-yellow">Course</span>
			<span class="label-circle card-status" v-if="inProgress || item.is_completed">
				<span class="label-circle-inner text-center">
					<template v-if="inProgress">
						<span class="d-block text-base font-medium flex items-center">
							{{ item.completedLessonCountForUser }} <span class="text-xs">of</span> {{ item.lessonCount }}
						</span>
					</template>
					<template v-else>
						<i class="tbb-icon-check tbb-icon-2x"></i>
					</template>
					<span class="d-block font-medium">completed</span>
				</span>
			</span>
	  	</div>

	  	<div class="card-content">
            <h4 class="card-title">{{ item.title }}</h4>
	  		<div class="card-info">
				<span class="card-info-item">
					<strong>{{ item.lessonCount }}</strong> Lesson<template v-if="item.lessonCount !== 1">s</template>
				</span>
				<span class="card-info-item card-info-item-thin" v-if="inProgress">
					{{ item.percentComplete }} Complete
				</span>
	  		</div>
			<div class="card-actions">
				<favorite-toggle :item="item" entity-type="course"></favorite-toggle>
			</div>
	  	</div>
	</a>
</template>
<script>
	import CourseCard from './course-card.vue';

	export default{
		mixins: [CourseCard],

		computed: {
			cardMediaStyle() {
				return 'background-image:url(' + (this.item.preview || '/img/temp2.jpg') + ')';
			},
			inProgress() {
				return this.item.is_started && !this.item.is_completed;
			}
		}
	}
</script>
